import React, { Component } from 'react';
import { connect } from 'react-redux';
import { change } from 'redux-form';
import { injectIntl, FormattedMessage } from 'react-intl';
import Geosuggest from 'react-geosuggest';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from 'react-geosuggest/module/geosuggest.css';
import t from './PlacesSuggest.css'
import { googleMapAPI } from '../../../config';
import messages from '../../../locale/messages';

class PlacesSuggest extends Component {

  constructor(props) {
    super(props);
    this.state = {
      noResult: false,
      noInput: false,
      inputValue: props.defaultValue || ''
    };

    this.handleSelectSuggest = this.handleSelectSuggest.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
  };

  componentDidUpdate(prevProps) {
    // Update input value when defaultValue changes (e.g., from map click)
    if (prevProps.defaultValue !== this.props.defaultValue) {
      this.setState({ inputValue: this.props.defaultValue || '' });
      if (this._geoSuggest) {
        this._geoSuggest.update(this.props.defaultValue || '');
      }
    }
  }

  async handleSelectSuggest(data) {
    const { handleData } = this.props;
    this.setState({ noResult: false });
    handleData(data);
  };

  async handleChange(input) {
    this.setState({ 
      noInput: !input,
      inputValue: input
    });
  }

  async handleBlur(input) {
    this.setState({ noInput: !input });
  }

  render() {
    const { label, className, containerClassName, defaultValue, form, error } = this.props;
    const { noResult, noInput, inputValue } = this.state;
    const { formatMessage } = this.props.intl;

    return (
      <>
        <Geosuggest
          ref={el => this._geoSuggest = el}
          placeholder={label}
          inputClassName={className}
          initialValue={inputValue}
          className={containerClassName}
          onBlur={this.handleBlur}
          onChange={this.handleChange}
          onSuggestSelect={this.handleSelectSuggest}
          onSuggestNoResults={(value) => {
            value && this.setState({ noResult: true })
          }}
        />

        {form == 'signup' ?
          noResult && <span className={'arrow_box'}>{formatMessage(messages.invalidAddress)}</span>
          :
          noResult && <span className={'placeError'}>{formatMessage(messages.invalidAddress)}</span>
        }

        {form == 'signup' ?
          noInput && !error && <span className={'arrow_box'}>{formatMessage(messages.required)}</span>
          :
          noInput && <span className={'placeError'}>{formatMessage(messages.required)}</span>
        }
      </>
    );
  }
};

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = {
  change
};

export default injectIntl(withStyles(s)(connect(mapStateToProps, mapDispatchToProps)(PlacesSuggest)));
